import axiosIns from '@/api/axios';
import querystring from 'query-string';

export const GET_DATA_LIST = (params) => {
  return axiosIns.get(`/im-number?${params}`);
};

export const GET_BY_BUDGET_TASK = (params) => {
  return axiosIns.get(`/im-number/get-by-budget-task?${params}`);
};

export const GET_FOR_PO = (params) => {
  return axiosIns.get(`/im-number/list-for-po?${params}`);
};

export const GET_LIST_FILTER_YEAR = (params) => {
  return axiosIns.get(`/im-number/list-filter-year`);
};

export const GET_LIST_FILTER_DEPARTMENT = (params) => {
  return axiosIns.get(`/im-number/list-filter-department`);
};

export const CREATE_DATA = (body) => {
  return axiosIns.post('/im-number', body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
export const CREATE_DATA_PK = (body) => {
  return axiosIns.post('/im-number-pk', body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const DELETE_DATA = (id) => {
  return axiosIns.delete(`/im-number/${id}`);
};
export const DELETE_DATA_PK = (id) => {
  return axiosIns.delete(`/im-number-pk/${id}`);
};

export const UPDATE_DATA = (body) => {
  return axiosIns.put(`/im-number/${body.id}`, body.data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
export const UPDATE_DATA_PK = (body) => {
  return axiosIns.put(`/im-number-pk/${body.id}`, body.data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const GET_DETAIL = (id) => {
  return axiosIns.get(`/im-number/${id}`);
};
